import { DreamBlock } from '@typedream/core';
import { createTElementPluginFactory } from '../../plate';
import { ELEMENT_NAVBAR } from '../../pluginKeys';
import { NavbarRootElementEditor } from './components/NavbarElement';
import { getDefaultNavbarValue } from './defaults';
import { withNavbar } from './withNavbar';

export const createNavbarPlugin = createTElementPluginFactory({
  key: ELEMENT_NAVBAR,
  component: NavbarRootElementEditor,
  withOverrides: withNavbar,
  isVoid: true,
  options: {
    isDreamBlock: true,
    isSelectable: false,
    isResizable: false,
    isDraggable: false,
    isDroppable: false,
    meta: {
      img: '/canvas/images/navbar.png',
      title: 'Navbar',
      subtitle:
        'Navbar... in Slate!',
      keywords: ['navbar', 'navigation'],
    },
    format: {
      formatType: 'block',
      blurAfterSet: true,
      insertNode: getDefaultNavbarValue() as unknown as DreamBlock,
      turnInto: [],
      focusableWhenEmpty: false,
      validProperties: [],
      validChildrenTypes: [],
    },
  },
});
